import {
  SUBSCRIPTION_TIERS,
  useImpersonationDraft,
  WorkspaceType,
} from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { Pill } from '../crop-circle/Components/Pill';
import { spacing, typography } from '../crop-circle/tokens';
import { Colors } from '../../themes/colors';

export const ImpersonationFilterScreen = () => {
  const { t } = useTranslation();
  const { draft, setDraft } = useImpersonationDraft();

  const tiers = draft.subscriptionTiers ?? [];
  const types = draft.types ?? [];

  const toggleTier = (tierId: string) => {
    const next = tiers.includes(tierId)
      ? tiers.filter((id) => id !== tierId)
      : [...tiers, tierId];
    setDraft({ subscriptionTiers: next });
  };

  const toggleType = (type: string) => {
    const next = types.includes(type)
      ? types.filter((id) => id !== type)
      : [...types, type];
    setDraft({ types: next });
  };

  return (
    <View style={styles.container}>
      <ScrollView style={styles.scrollView} contentContainerStyle={styles.scrollContent}>
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('workspace.filter.tierSelection')}
          </Text>
          <View style={styles.optionsContainer}>
            {SUBSCRIPTION_TIERS.map((tier) => {
              const isSelected = tiers.includes(tier.id);
              return (
                <Pill
                  key={tier.id}
                  label={tier.name}
                  selected={isSelected}
                  showIcon={false}
                  onPress={() => toggleTier(tier.id)}
                />
              );
            })}
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('workspace.filter.typeSelection')}
          </Text>
          <View style={styles.optionsContainer}>
            {Object.values(WorkspaceType).map((type) => {
              const isSelected = types.includes(type);
              return (
                <Pill
                  key={type}
                  label={t(`workspace.types.${type}`)}
                  selected={isSelected}
                  showIcon={false}
                  onPress={() => toggleType(type)}
                />
              );
            })}
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.role.canvas,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingHorizontal: spacing.lg,
    paddingBottom: spacing['8xl'] + spacing['4xl'],
  },
  section: {
    paddingTop: spacing['2xl'],
  },
  sectionTitle: {
    ...typography.label.large,
    fontWeight: '700',
    color: Colors.role.textPrimary,
    marginBottom: spacing.md,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  optionsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
});
